/**
 * Core Reducers for RemitSlice
 * 
 * Handles basic remit state management operations.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RemitSliceState } from '../state';
import { RemitView } from '../../types/remitTypes';

/**
 * Set the current remit
 */
export const setRemit: CaseReducer<
  RemitSliceState,
  PayloadAction<RemitView | null>
> = (state, action) => {
  state.currentRemit = action.payload;
  state.remitBackup = action.payload;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
  state.isLoading = false;
  state.selectedClaimId = null;
  state.selectedServiceLineId = null;
};

/**
 * Clear the current remit
 */
export const clearRemit: CaseReducer<RemitSliceState> = (state) => {
  state.currentRemit = null;
  state.remitBackup = null;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
  state.isLoading = false;
  state.selectedClaimId = null;
  state.selectedServiceLineId = null;
};

/**
 * Update fields on the current remit
 */
export const updateRemit: CaseReducer<
  RemitSliceState,
  PayloadAction<Partial<RemitView>>
> = (state, action) => {
  if (state.currentRemit) {
    state.currentRemit = {
      ...state.currentRemit,
      ...action.payload,
    };
    state.isEdited = true;
  }
};

/**
 * Restore remit from backup (discard changes)
 */
export const restoreFromBackup: CaseReducer<RemitSliceState> = (state) => {
  if (state.remitBackup) {
    state.currentRemit = state.remitBackup;
    state.isEdited = false;
    state.editedFields = [];
    state.validationErrors = {};
  }
};

/**
 * Set loading state
 */
export const setLoading: CaseReducer<
  RemitSliceState,
  PayloadAction<boolean>
> = (state, action) => {
  state.isLoading = action.payload;
};
